"use strict";
var PostponedFlightsViewModel = (function () {
    function PostponedFlightsViewModel() {
    }
    return PostponedFlightsViewModel;
}());
exports.PostponedFlightsViewModel = PostponedFlightsViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/postponed-flights-view.model.js